import axios from 'axios'
import { appConfig } from '../../config/app-config'
import { getBearerToken } from '../../auth/auth.utils'
import { errorResponseInterceptor } from '../interceptors/responseInterceptor'

export const LuigiClient = axios.create({
    baseURL: appConfig.luigiApiBaseUrl,
    headers: {
        'X-Caller-Service': 'experts-client',
    },
})

LuigiClient.interceptors.request.use(config => {
    const token = getBearerToken()
    if (token) {
        config.headers.Authorization = token
    }
    return config
})

LuigiClient.interceptors.response.use(response => response, errorResponseInterceptor)
